<template>

  <div class="w-full h-full flex flex-col p-6 lg:p-10 bg-gray-100">
    <div class="w-full flex flex-col justify-center items-start mb-5 gap-1">
      <p class="text-gray-400 text-sm"><span @click="$router.push('/services')"
          class="hover:underline cursor-pointer">Services</span> / Online Bank Account Enrollment Form</p>

      <div class="flex flex-col lg:flex-row items-start lg:items-center justify-between w-full gap-3">
        <h1 class="text-theme-primary text-2xl lg:text-3xl font-semibold">Online Bank Account Enrollment Form</h1>
        <div class="bg-primary rounded-full px-3 py-1 text-white cursor-pointer hover:brightness-110"
          @click="bank_modal = true">
          Check Enrollment Status
        </div>
      </div>
    </div>

    <div ref="tabContainer" class="bg-white overflow-y-auto flex flex-col p-4 lg:p-8 rounded-2xl">
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-10">
        <div class="flex flex-col gap-3">
          <TextBoxField :initial="$store.state.credentials.name" id="name" placeholder="Name" class="w-full"
            :max_length="23" disable />
          <TextBoxField :initial="$store.state.credentials.account_no" id="account_no"
            placeholder="PAFCPIC Account Number" class="w-full" disable :max_length="23" />
          <TextBoxField :initial="$store.state.credentials.email" id="email" placeholder="Email Address" class="w-full"
            :need_update="'email'" disable :max_length="23" />
          <TextBoxField
            :initial="$store.state.credentials.mobile ? $store.state.credentials.mobile.replace('+63', '') : ''"
            id="mobile_no" type="mobile" :max_length="9" :need_update="'mobile'" disable placeholder="Contact Number"
            class="w-full" />
        </div>

        <div class="flex flex-col gap-3">
          <ComboBoxControl label="Bank" fieldId="bank_key" v-model="bank_key" :required="true" :options="bankOptions" />
          <TextBoxField
              id="bank_actnumber"
              placeholder="Bank Account Number"
              class="w-full"
              :max_length="11"
              :required="true"
              :numbersOnly="true"
              :noSpaces="true"
              :value="bank_actnumber"
              @changed="bank_actnumber = $event.value"
          />

          <div>
            <UploadTextBoxFieldView id="valid_id" placeholder="Upload Proof of Bank Account"
              accept=".jpg,.jpeg,.png,.pdf" :required="true" @update:file="bank_doc = $event" />
            <p class="italic text-gray-500 text-sm">Note: Please upload a clear, valid proof of bank account. Ensure
              that all details are visible, unblurred, and not cropped (.jpg, .jpeg, .png, .pdf).</p>
          </div>
          <ComboBoxControl label="Choose a PSO that will verify your enrollment" fieldId="nationality"
            v-model="branch_code" :required="true" :options="branchOptions" />

        </div>
      </div>


      <div class="mt-8">
        <div class="flex flex-row space-x-2 pb-4 items-start text-gray-600">
          <input type="checkbox" id="agree1" v-model="agree1"
            class="cursor-pointer w-6 h-6 accent-[#016B00] flex-shrink-0" />
          <label for="agree1" class="cursor-pointer select-none">
            By accomplishing and submitting this form, I hereby certify that the above information is true and correct
            of my best knowledge of the purpose of the PAFCPIC Electronic Fund Transfer service. I am hereby allowing
            PAFCPIC to update my member records and to process the personal information I have provided herein in
            accordance with the Data Privacy Act of 2012 and the PAFCPIC Privacy Policy (accessible at
            <a href="https://pafcpic.ph/privacy-policy" target="_blank" rel="noopener noreferrer"
              class="underline break-all" @click.stop>
              https://pafcpic.ph/privacy-policy
            </a>).<span class="text-red-600"> *</span>
          </label>
        </div>

        <div class="flex flex-row space-x-2 pb-4 items-start text-gray-600">
          <input type="checkbox" id="agree2" v-model="agree2"
            class="cursor-pointer w-6 h-6 accent-[#016B00] flex-shrink-0" />
          <label for="agree2" class="cursor-pointer select-none">
            I confirm that the Bank Account Number provided is accurate and complete. I acknowledge and agree that
            PAFCPIC shall bear no responsibility or liability for any losses, delays, or errors arising from the
            submission of incorrect or incomplete bank account information. <span class="text-red-600"> *</span>
          </label>
        </div>

        <div class="flex flex-row space-x-2 pb-4 items-start text-gray-600">
          <input type="checkbox" id="agree3" v-model="agree3"
            class="cursor-pointer w-6 h-6 accent-[#016B00] flex-shrink-0" />
          <label for="agree3" class="cursor-pointer select-none">
            I also acknowledge that I am aware and agree that there will be a delay in the transferring of funds in
            using the Electronic Fund Transfer (EFT) service. <span class="text-red-600"> *</span>
          </label>
        </div>
      </div>

      <div class="flex w-full justify-end mt-4">
        <Button rounded @clicked="triggerSubmit" button_text="Submit" :theme="'text-white'"
          class="xs:self-end xs:mr-0 max-w-full lg:max-w-xs px-4 mb-3" :disabled="!canSubmit" />
      </div>



    </div>

  </div>


  <ModalControl v-show="show_message_modal" v-bind:display="show_message_modal" :error="this.error"
    :success="this.success" :note="this.warning" :question="this.question" z_value="z-50"
    @positiveClick="handlePositiveClick()" :positiveButton="this.positiveText" @negativeClick="handleNegativeClick()"
    :negativeButton="this.negativeText" :default_width="'max-w-xl'" id='vote_modal'>
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
      {{ this.modal_message }}
    </div>
  </ModalControl>

  <ModalControl v-show="pin_modal" v-bind:display="pin_modal" z_value="z-50" :default_width="'max-w-xl'" id='vote_modal'
    closable @closed="pin_modal = false">
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-center text-center items-center">
      <PINValidationView @validated="submitForm" />
    </div>
  </ModalControl>

  <ModalControl v-show="bank_modal" v-bind:display="bank_modal" z_value="z-50" :default_width="'max-w-3xl'"
    id='bank_modal' closable @closed="bank_modal = false">
    <div class="w-full px-5 pt-2 pb-4 flex flex-col text-xl justify-start text-left items-start">
      <p class="mt-3 lg:mt-6 text-theme-primary text-xl lg:text-2xl font-semibold mb-3 lg:mb-6">Bank Enrollments</p>
      <div v-if="$store.state.bank_info && $store.state.bank_info.bank_info.length" class="w-full flex flex-col gap-4">
        <div v-for="(item, index) in $store.state.bank_info.bank_info" :key="index"
          class="bg-gray-50 border rounded-lg p-5">
          <div class="grid grid-cols-2 gap-y-3 gap-x-3 lg:gap-x-6 text-base">
            <div>
              <p class="text-gray-500 text-xs lg:text-sm">Bank</p>
              <p class="font-semibold text-sm lg:text-base">{{ item.bank_info.bank_type }}</p>
            </div>

            <div>
              <p class="text-gray-500 text-xs lg:text-sm">Account Number</p>
              <p class="font-semibold text-sm lg:text-base">{{ item.bank_info.bank_actnumber }}</p>
            </div>

            <div>
              <p class="text-gray-500 text-xs lg:text-sm">Account Name</p>
              <p class="font-semibold text-sm lg:text-base">{{ item.bank_info.acct_name }}</p>
            </div>

            <div>
              <p class="text-gray-500 text-xs lg:text-sm">Date Enrolled</p>
              <p class="font-semibold text-sm lg:text-base">{{ formatDate(item.bank_info.date) }}</p>
            </div>

            <div>
              <p class="text-gray-500 text-xs lg:text-sm">Branch Code</p>
              <p class="font-semibold text-sm lg:text-base">
                {{ item.bank_info.branch_code || '-' }}
              </p>
            </div>

            <div>
              <p class="text-gray-500 text-xs lg:text-sm">Status</p>
              <p class="font-semibold text-sm lg:text-base">
                {{ item.bank_info.status || 'Pending' }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="w-full flex justify-center items-center bg-gray-100 rounded-lg py-16">
        <p class="italic text-gray-500">No bank enrollment found.</p>
      </div>
    </div>
  </ModalControl>



</template>

<script>
import User from '@/services/User';
import mixin from '@/mixin';
import ModalControl from '@/components/controls/ModalControl.vue';
import ComboBoxControl from '@/components/controls/ComboBoxControl.vue';
import Button from '@/components/controls/ButtonControl.vue';
import UploadTextBoxFieldView from '@/components/controls/UploadTextBoxFieldView.vue';
import PINValidationView from '@/components/sections/PINValidationView.vue';

import TextBoxField from '@/components/controls/TextBoxField.vue';

export default {
  name: 'v-baseform',
  inject: ['setLoading'],
  mixins: [mixin],
  data() {
    return {
      pin_modal: false,
      bank_modal: false,
      show_message_modal: false,
      modal_message: '',
      success: false,
      warning: false,
      error: false,
      question: false,
      positiveText: '',
      negativeText: '',
      expired: false,

      bank_actnumber: "",
      bank_key: null,
      bank_doc: null,
      branch_code: null,

      agree1: false,
      agree2: false,
      agree3: false,

      yesNoOptions: [
        { label: 'YES', value: 1 },
        { label: 'NO', value: 0 }
      ],
    };
  },
  components: {
    TextBoxField,
    ComboBoxControl,
    ModalControl,
    Button,
    UploadTextBoxFieldView,
    PINValidationView

  },
  mounted() {
    const state = this.$store.state;

    if (!state.credentials.username) {
      this.getUserInfo();
    } else {
      this.checkUserFlow();
    }
  },
  computed: {
    canSubmit() {
      return (
        this.bank_actnumber != null &&
        this.bank_key !== null &&
        this.bank_doc &&
        this.branch_code !== null &&
        this.agree1 &&
        this.agree2 &&
        this.agree3
      );
    },
    bankOptions() {
      return (this.$store.state.bank_types || []).map(bank => ({
        label: bank.bank_type + ' - ' + bank.bank_name,
        value: bank.bank_key
      }));
    },
    branchOptions() {
      return (this.$store.state.branches || []).map(branch => ({
        label: branch.name,
        value: branch.code
      }));
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return '-';

      const d = new Date(date);

      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const year = d.getFullYear();

      return `${month}/${day}/${year}`;
    },
    triggerSubmit() {
      this.show_message_modal = true;
      this.modal_message = "Are you sure you want to submit the form? Please ensure that all information provided is accurate and complete.";
      this.error = false;
      this.success = false;
      this.warning = false;
      this.question = true;
      this.negativeText = "Cancel";
      this.positiveText = "Submit";
    },
    handlePositiveClick() {
      this.show_message_modal = false;
      if (this.expired) {
          this.closed();
      } else if (this.question) {
          this.pin_modal = true;
          this.error = false;
          this.success = false;
          this.warning = false;
          this.question = false;
      } else if (this.success) {
          this.$router.push('/services');
      }
    },
    handleNegativeClick() {
      this.show_message_modal = false;
    },
    backToStart() {
      this.success_modal = false;
      this.error_modal = false;
      this.$router.push('/bank-account-opening');
      this.$store.state.formDataPNB = {};
    },
    submitForm() {
      this.setLoading(true);
      this.pin_modal = false;

      const formData = new FormData();

        formData.append('member_key', this.$store.state.credentials.key);
        formData.append('bank_actnumber', this.bank_actnumber);
        formData.append('bank_key', this.bank_key);
        formData.append('acct_name', this.$store.state.credentials.name);
        formData.append('branch_code', this.branch_code);
        formData.append('mobile_number', this.$store.state.credentials.mobile);
        formData.append('email', this.$store.state.credentials.email);

        formData.append(
          'bank_type',
          this.$store.state.bank_types.find(
            bank => bank.bank_key === this.bank_key
          )?.bank_type || ''
        );

        // Upload the actual File object
        formData.append('bank_doc', this.bank_doc.file);

        // Optional: inspect the payload
        for (const [key, value] of formData.entries()) {
          console.log(key, value);
        }

      // const formData = {
      //   member_key: this.$store.state.credentials.key,
      //   bank_actnumber: this.bank_actnumber,
      //   bank_key: this.bank_key,
      //   acct_name: this.$store.state.credentials.name,
      //   branch_code: this.branch_code,
      //   mobile_number: this.$store.state.credentials.mobile,
      //   email: this.$store.state.credentials.email,
      //   bank_type: this.$store.state.bank_types.find(
      //       bank => bank.bank_key === this.bank_key
      //     )?.bank_type || "",
      //   bank_doc: this.bank_doc.base64
      // }

      User.submitBAEF(formData)
        .then((response) => {
          this.setLoading(false);
          this.modal_message = 'Form submitted successfully';
          this.show_message_modal = true;
          this.error = false;
          this.success = true;
          this.question = false;
          this.warning = false;
          this.positiveText = 'Ok';
          this.negativeText = null;
        })
        .catch((error) => {
          this.setLoading(false);
          this.modal_message = error?.response?.data?.message || 'An error occurred';
          this.show_message_modal = true;
          this.error = true;
          this.success = false;
          this.question = false;
          this.warning = false;
          this.positiveText = 'Ok';
          this.negativeText = null;
        });

    },
    closed() {
      let that = this;

      that.$cookies.remove('user');
      that.$cookies.remove('user_session');
      that.$router.push('/');
      that.show_message_modal = false;
    },
    getEndpoints() {
      this.setLoading(true);
      const memkey = this.$store.state.credentials.key;
      User.getBankInfo(memkey)
        .then((response) => {
          const data = response.data.data;
          const store = this.$store.state;

          store.bank_info = data;
          // console.log('Bank Info: ', store.bank_info);
          this.getBranches();
        })
        .catch((error) => {
          this.setLoading(false);
          this.modal_message = error?.response?.data?.message || 'An error occurred';
          this.show_message_modal = true;
          this.error = true;
          this.success = false;
          this.question = false;
          this.warning = false;
          this.positiveText = 'Ok';
        });
    },
    getBranches() {
      this.setLoading(true);
      User.getBranches()
        .then((response) => {
          const data = response.data.data;
          const store = this.$store.state;

          store.branches = data;
          // console.log('Branches: ', store.branches);
          this.getBankTypes();
        })
        .catch((error) => {
          this.setLoading(false);
          this.modal_message = error?.response?.data?.message || 'An error occurred';
          this.show_message_modal = true;
          this.error = true;
          this.success = false;
          this.question = false;
          this.warning = false;
          this.positiveText = 'Ok';
        });
    },
    getBankTypes() {
      this.setLoading(true);
      User.getBankTypes()
        .then((response) => {
          const data = response.data.data;
          const store = this.$store.state;

          store.bank_types = data;
          this.setLoading(false);
        })
        .catch((error) => {
          this.setLoading(false);
          this.modal_message = error?.response?.data?.message || 'An error occurred';
          this.show_message_modal = true;
          this.error = true;
          this.success = false;
          this.question = false;
          this.warning = false;
          this.positiveText = 'Ok';
        });
    },
    getProvincesLookup() {
      this.setLoading(true);
      User.getProvinces()
        .then((response) => {
          const data = response.data.data;
          const store = this.$store.state;

          store.provinces = data;
          console.log('Provinces data stored in Vuex:', store.provinces);
          this.setLoading(false);
        })
        .catch((error) => {
          this.setLoading(false);
          this.error_message = error?.response?.data?.message || 'An error occurred';
          this.error_modal = true;
        });
    },
    getUserInfo() {
      let that = this;
      const cookie = that.$cookies;
      const store = that.$store;
      let state = store.state;
      that.setLoading(true);

      User.recoverSession(cookie.get('user_session').hash).then(function (response) {
        let data = response.data.data;
        state.logged = true;
        state.credentials.first_name = data.info.first_name;
        state.credentials.last_name = data.info.last_name;
        state.credentials.middle_name = data.info.middle_name;
        state.credentials.regular = data.info.regular;
        state.credentials.express = data.express;
        state.credentials.pso_enroll = data.pso_enroll;
        state.credentials.pin_update = data.pin_update;
        state.credentials.membership_date = data.info.membership_date || null;
        state.credentials.status = data.status || null;
        state.credentials.account_no = data.info.account_number;
        state.gaUser = data.ga;
        state.credentials.email = data.info.email;
        state.credentials.gender = data.info.gender;
        state.credentials.birthdate = data.info.date_of_birth;
        state.credentials.age = data.info.age;
        state.credentials.membership_type = data.info.membership_type;
        state.credentials.registered_date = data.info.registered;
        state.credentials.key = data.key;
        state.credentials.mobile = data.info.mobile;
        state.credentials.name = data.info.first_name + " " + data.info.last_name + (data.info.suffix ? " " + data.info.suffix : "");
        state.credentials.suffix = data.info.suffix ?? '';
        state.credentials.qr = data.qr;
        state.credentials.uuid = data.uuid;
        state.credentials.serial_no = data.info.serial_number;
        state.credentials.timestamp = response.timestamp;
        state.credentials.username = data.info.username;
        state.credentials.hash = data.hash;
        state.credentials.has_pin = data.has_pin;
        state.credentials.deactivated = data.deactivated;
        state.credentials.tin = data.info.tin;
        state.balances = data.balances;
        const type2Config = data.config.find(item => item.type === 2);
        if (type2Config) {
          state.credentials.config = { status: type2Config.status };
        } else {
          state.credentials.config = null;
        }
        that.account_number = state.credentials.account_no;
        that.full_name = state.credentials.name;
        that.gender = state.credentials.gender;
        that.Astatus = state.credentials.status;
        that.Membership = state.credentials.membership_type;
        that.Member_since = state.credentials.membership_date;
        that.email = state.credentials.email;
        that.mobile = state.credentials.mobile;
        that.tin = state.credentials.tin;
        that.age = state.credentials.age;
        that.birthdate = state.credentials.birthdate;
        that.serial = state.credentials.serial_no == null ? '??????' : state.credentials.serial_no;
        that.username = state.credentials.username;
        that.registered = state.credentials.registered_date;
        that.qr = data.qr;
        that.currentTin = state.credentials.tin;
        that.express = data.express;
        that.deactivated = data.deactivated;
        const rawRegisteredDate = state.credentials.registered_date;
        if (rawRegisteredDate) {
          const parts = rawRegisteredDate.split('-');
          that.registered = `${parts[1]}/${parts[2]}/${parts[0]}`;
        }

        const rawBirthdate = state.credentials.birthdate;
        if (rawBirthdate) {
          const parts = rawBirthdate.split('-');
          that.birthdate = `${parts[1]}/${parts[2]}/${parts[0]}`;
        }

        that.checkUserFlow();
        that.setLoading(false);

      }).catch(function (error) {
        that.error = true;
        that.positiveText = 'Ok';
        that.negativeText = null;
        that.setLoading(false);
        that.show_message_modal = true;
        that.modal_message = error.response.data.message;
        if (error.response.status == 403) {
          that.positiveText = 'Logout';
          that.negativeText = null;
          that.expired = true
          that.modal_message = "Your session has expired. Please log in again.";
          that.$store.state.logged = false;
        }
      });
    },
    checkUserFlow() {
      const that = this;
      const state = that.$store.state;
      const noContact = !state.credentials.mobile || !state.credentials.email;
      const config = state.credentials.config;
      const temporaryPIN = state.credentials.pin_update;
      const isValidated = that.$cookies.get('validated');

      this.getEndpoints();
      // this.getBranches();

      if (state.credentials.deactivated) {
        this.$router.push('/user/settings');
        return;
      }

      if (noContact) {
        state.credentials.noContact = noContact;
        this.show_update = true;
        return;
      }

      if (state.credentials.enrolled_pin) {
        const hasValidConfig = config && config.status;
        const noContact = state.credentials.noContact;
        state.credentials.enrolled_pin = false;

        if (noContact) {
          that.show_update = false;
          that.show_pin_modal = false;
          that.show_otp_modal = false;
          that.$cookies.set('validated', true);
        } else {
          if (hasValidConfig) {
            that.requestOTP();
          } else {
            that.show_update = false;
            that.show_pin_modal = false;
            that.show_otp_modal = false;
            that.$cookies.set('validated', true);
          }
        }
        return;
      }


      if (!isValidated) {
        if (state.credentials.has_pin) {
          this.show_pin_modal = true;
        } else {
          this.$router.push('/user/settings');
        }
      }

      if (temporaryPIN) {
        this.$router.push('/user/settings');
        state.credentials.edit_temporary = true;
        return;
      }

      const missingInfo = !state.credentials.mobile || !state.credentials.email ||
        !state.credentials.tin || !state.credentials.birthdate;

      if (missingInfo && !that.$cookies.get('skipped')) {
        this.show_update = true;
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  overflow: hidden;
  /* prevents whole page scroll */
}
</style>